import React from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { COLORS } from "../../../styles/colors";

const styles = (theme) => ({
  customButton: {
    borderRadius: "25px",
    border: "1px solid transparent",
    padding: "15px 28px !important",
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "20px",
    textAlign: "center",
    textTransform: "none",
    width: "fit-content",
    minWidth: "120px",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      padding: "11px 24px !important",
    },
  },
  primary: {
    backgroundColor: "var(--button-primary)",
    color: "var(--button-secondary)",
    "&:hover": {
      backgroundColor: "var(--button-primary)",
    },
    "&:disabled": {
      opacity: 0.5,
    },
  },
  secondary: {
    backgroundColor: "var(--online-button-secondary)",
    color: "var(--online-button-primary)",
    borderColor: "var(--online-button-primary)",
    "&:hover": {
      backgroundColor: "var(--lightViolet)",
    },
    "&:disabled": {
      opacity: 0.5,
    },
  },
  success: {
    backgroundColor: "var(--button-success)",
    color: COLORS.white,
    "&:hover": {
      backgroundColor: "var(--button-success)",
    },
    "&:disabled": {
      opacity: 0.5,
    },
  },
  customWidth: {
    minWidth: "fit-content",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    padding: "15px 10px",
  }
});

const CustomButton = ({
  classes,
  type = "button",
  message = "Custom Button",
  endIcon = null,
  startIcon = null,
  isFullWidth = false,
  color = "primary",
  onClick = null,
  disabled = false,
  size = "medium",
  classProp = null,
  style = null,
}) => {
  const buttonProps = {
    type: type,
    onClick: onClick,
    color: "default",
    startIcon: startIcon,
    variant: "contained",
    disabled: disabled,
    size: size,
    className: `${classes.customButton} ${classes[color]} ${classProp} ${classes.customWidth}`,
    fullWidth: isFullWidth,
    styles: style,
  };

  return <Button {...buttonProps}>{message}</Button>;
};

CustomButton.propTypes = {
  classes: PropTypes.object.isRequired,
  endIcon: PropTypes.element,
  startIcon: PropTypes.element,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.string,
  isFullWidth: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.oneOf(["primary", "secondary", "success"]),
  disabled: PropTypes.bool,
};

export default withStyles(styles)(CustomButton);
